/** Backend rejects limit above 100, so a full group list is several pages. */
export const MAX_MONITORING_PAGES = 50;

export const monitoringPageCount = (totalPages: number | undefined): number => {
  const count = Math.floor(Number(totalPages));
  if (!Number.isFinite(count) || count < 1) return 1;
  return Math.min(count, MAX_MONITORING_PAGES);
};

export const mergePagedLists = <T extends { data: unknown[] }>(pages: readonly T[]): T => {
  const [first, ...rest] = pages;
  return {
    ...first,
    data: [first, ...rest].flatMap((page) => page.data ?? []),
  };
};
